// 组成员 store
import * as groupMember from "@/api/manage/groupMember";

const state = {
	groupStructure: [],
};
const getters = {
	groupStructure: (state) => state.groupStructure,
};
const actions = {
	GetStructure({ commit }, data) {
		return new Promise((resolve, reject) => {
			groupMember
				.getStructure(data)
				.then((response) => {
					commit("GET_GROUP_STRUCTURE", response);
					resolve();
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
const mutations = {
	GET_GROUP_STRUCTURE: (state, groupStructure) => {
		state.groupStructure = groupStructure;
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/groupMember.js